module.exports = __webpack_public_path__ + "static/media/2019-revisorns-utlatande.325c6042.pdf";